export default __webpack_public_path__ + "static/media/Node-JS.63efd2e2.svg";